/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>


        <div class="mc-form-register">

          <div class="mc-form-register-input">

            <ion-item>
              <ion-label position="floating">{{$t('Register.phone')}} *</ion-label>
              <ion-input
                type="text"
                name="telephone"
                :value="user.telephone"
                @input="user.telephone = $event.target.value;"
                @ionBlur="checkedPhoneNumber = null"
                :placeholder="$t('Register.phone')"
              ></ion-input>
              <ion-icon
                style="margin-top: 16px"
                slot="end"
                size="large"
                color="primary"
                class="rotating"
                v-if="this.$store.state.registerStore.statusCheckPhoneNumberValidity == 'loading'"
                name="md-sync"
              ></ion-icon>
            </ion-item>
            <div v-if="$v.user.telephone.$error">
              <div class="mc-error-label"  v-if="!$v.user.telephone.required">{{$t('Validation.required')}}</div>
              <div class="mc-error-label"  v-if="!$v.user.telephone.minLength">{{$t('Validation.minLengthTel')}}</div>
              <div class="mc-error-label" v-if="!$v.user.telephone.checkPhoneNumberValidity">{{ this.$store.state.registerStore.checkPhoneNumberValidityMessage }}</div>
            </div>

            <ion-item v-on:click="goGeoSearch('register_address', 'search')">
              <ion-label position="floating">{{$t('Register.address')}} *</ion-label>
              <ion-input
                type="text"
                name="address"
                :value="displayAddress"
                readonly="true"
                class="no-clickable ellipsis"
                v-bind:placeholder="$t('Register.address')"
              ></ion-input>
            </ion-item>
            <div v-if="$v.user.addresses.$error">
              <div class="mc-error-label"  v-if="!$v.user.addresses.required">{{$t('Validation.required')}}</div>
              <div class="mc-error-label"  v-if="!$v.user.addresses.fullAddress">{{$t('Register.fullAddress')}}</div>
            </div>
            <br>

            <ion-item>
              <ion-label position="floating">{{$t('Register.gender')}} <span v-if="genderRequired">*</span></ion-label>
              <ion-select
                required
                :value="user.gender"
                @ionChange="user.gender = Number($event.target.value)"
                :cancel-text="$t('Commons.cancel')"
                :placeholder="$t('Register.gender')"
              >
                <ion-select-option value="3">{{$t('Register.nc')}}</ion-select-option>
                <ion-select-option value="2">{{$t('Register.male')}}</ion-select-option>
                <ion-select-option value="1">{{$t('Register.female')}}</ion-select-option>
              </ion-select>
            </ion-item>
            <div v-if="$v.user.gender.$error">
              <div class="mc-error-label"  v-if="!$v.user.gender.required">{{$t('Validation.required')}}</div>
            </div>

            <ion-item v-if="askBirthdate">
              <ion-label position="floating">{{ $t('Register.birthDate') }} <span v-if="requiredBirthdate">*</span></ion-label>
              <ion-datetime
                display-format="DD/MM/YYYY"
                picker-format="DD/MM/YYYY"
                :cancel-text="$t('Commons.cancel')"
                :done-text="$t('Commons.validate')"
                :value="user.birthDate"
                @ionChange="user.birthDate = $event.detail.value"
              ></ion-datetime>
            </ion-item>
            <div v-if="$v.user.birthDate.$error">
              <div class="mc-error-label"  v-if="!$v.user.birthDate.required">{{$t('Validation.required')}}</div>
              <div class="mc-error-label"  v-if="!$v.user.birthDate.isMaxBirthDate">{{$t('Validation.age', { value: minAge })}}</div>
            </div>
            <div class="mc-select-communities text-left" v-if="showCommunities && this.communities.length > 0">
              <ion-item class="item-communities">
                <ion-label position="floating">{{$t('Register.community')}} <span v-if="neededCommunities">*</span></ion-label>
                <ion-select
                  placeholder="Sélectionnez une communauté"
                  interface="alert"
                  cancel-text="Fermer"
                  ok-text="Valider"
                  :value="user.communityId"
                  @ionChange="setCommunities($event)"
                >
                  <ion-select-option
                    v-for="community in communities"
                    :key="community.id"
                    :value="community.id"
                  >{{ community.name }}</ion-select-option>
                </ion-select>
              </ion-item>
              <div v-if="$v.user.communityId.$error">
                <div class="mc-error-label"  v-if="!$v.user.communityId.required">{{$t('Validation.required')}}</div>
              </div>
            </div>
            <br>
            <ion-item lines="none">
              <ion-checkbox
                name="userAgreementAccepted"
                :value="user.userAgreementAccepted"
                color="success"
                slot="start"
                @ionChange="changeUserAgreementAccepted($event)"
                :checked="user.userAgreementAccepted"
              ></ion-checkbox>
              <ion-label class="no-white-space"><p>{{ $t('Register.userAgreementAccepted') }}</p></ion-label>
            </ion-item>
            <div v-if="$v.user.userAgreementAccepted.$error">
              <div class="mc-error-label"  v-if="!$v.user.userAgreementAccepted.required">{{$t('Validation.required')}}</div>
              <div class="mc-error-label"  v-if="!$v.user.userAgreementAccepted.checked">{{$t('Validation.required')}}</div>
            </div>


            <br>
            <a class="text-center pointer" v-on:click="$router.push('/article/1')">Voir les conditions</a>
            <a class="text-center pointer" v-if="hasProtection()" v-on:click="goToProtection()">Voir la politique de confidentialité</a>

            <br>
            <div class="text-asterisk text-left"><small>* Champ obligatoire</small></div>

          </div>

        </div>

</template>

<style lang="scss">

  .no-white-space {
    white-space: normal !important;
  }
  .mc-form-register {
    display: block;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;

    .mc-form-register-input {
      flex: 1;
      flex-direction: column;
      display: flex;
      justify-content: center
    }
  }

  .text-asterisk {
    font-size: 14px;
    color: rgba(0,0,0,0.4)
  }

</style>

<script>
  import {required, email, sameAs, minLength, requiredIf} from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'
    var moment = require('moment');

    const checked = value => value === true;
    const isMaxBirthDate = (value, vm) => {
      if (JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE)) {
        let n = new Date();
        n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
        return moment(value).isBefore(moment(n.toISOString()));
      } else {
        return true;
      }
    }

    export default {
        name: 'registerStep2',
        data () {
            return {
                maxBirthDate: this.getMaxBirthDate(),
                minAge: process.env.VUE_APP_REGISTER_MIN_AGE,
                askBirthdate: JSON.parse(process.env.VUE_APP_ASK_BIRTHDATE),
                requiredBirthdate: JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE),
                showCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY),
                neededCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY_NEEDED),
                genderRequired: JSON.parse(process.env.VUE_APP_GENDER_REQUIRED),
                fullAddressRequired: JSON.parse(process.env.VUE_APP_REGISTER_FULL_ADDRESS),
                communities: [],
                checkedPhoneNumber: null
            }
        },
        validations: {
            user: {
                telephone: {
                    required,
                    minLength: minLength(10),
                    checkPhoneNumberValidity(telephone) {
                      if (!this.checkedPhoneNumber) {
                        this.checkedPhoneNumber = this.$store.dispatch('checkPhoneNumberValidity', telephone).then(res => {
                          setTimeout(() => {
                            this.$parent.next()
                          }, 0)
                          return res
                        });
                        return this.checkedPhoneNumber
                      } else {
                        return this.checkedPhoneNumber
                      }
                    }
                },
                addresses: {
                    required,
                    fullAddress(address) {
                      return this.fullAddressRequired ? (address[0] ? (address[0].type === "housenumber" || address[0].type === "street" )  : false) : true;
                    }
                },
                gender: {
                    required : requiredIf(function () {
                      return this.genderRequired;
                    }),
                },
                birthDate: {
                    required :  requiredIf(function () {
                      return this.requiredBirthdate;
                    }),
                    isMaxBirthDate
                },
                userAgreementAccepted: {
                    required,
                    checked
                },
                communityId: {
                  required :  requiredIf(function () {
                    return this.neededCommunities;
                  }),
                }
            }
        },
        computed: {
            user : {
                get() {
                    return this.$store.state.registerStore.userToRegister
                },
                set() {
                    this.$store.commit('register_update', this.user);
                }
            },
            displayAddress : {
                get() {
                    return this.$store.state.registerStore.displayAddress
                }
            },
        },
        created() {
          if (this.showCommunities) {
            this.$store.dispatch('getAllCommunities', {query: '', number: 1000}).then(res => {
              this.communities = res.data['hydra:member']
            })
          }
        },
        methods: {
            getMaxBirthDate() {
              let n = new Date();
              n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
              return n.toISOString();
            },
            goGeoSearch(type, action) {
                this.$router.push({ name: "geoSearch", query: { type, action, fullAddressRequired: this.fullAddressRequired }});
            },
            validate() {
                this.$v.$reset();
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                } else {
                    return true;
                }
            },
            changeUserAgreementAccepted(event) {
                event.detail.checked ? ( this.user.userAgreementAccepted = true) : (this.user.userAgreementAccepted = false);
            },
            setCommunities(event) {
              this.user.communityId = event.detail.value;
            },
            hasProtection() {
              const t = this.$t("Contact.protection-external-link");
              return t !== "Contact.protection-external-link";
            },
            goToProtection() {
              const t = this.$t("Contact.protection-external-link");
              window.open(t, '_blank');
            }
        }
    }
</script>
